import { Controller } from "stimulus";
import i18next from "i18next";
export default class extends Controller {
  static targets = [
    "testResultsForm",
    "save",
    "saveRelease",
    "saveReleasePanels",
    "formStatus",
  ];
  static values = {
    stsIds: Array,
  };
  connect() {}

  testResultsFormTargetConnected(target) {
    target.addEventListener("turbo:before-fetch-request", (e) => {
      this.changeActivityFormButtons(true);
    });

    target.addEventListener("turbo:before-fetch-response", (e) => {
      if (e.detail.fetchResponse.response.ok) {
        this.scrollToSpecimenForm(this.stsIdsValue);
      }
      this.changeActivityFormButtons(false);
    });
  }

  closeForm(e) {
    e.preventDefault();
    this.element.innerHTML = "";
  }

  changeActivityFormButtons(status) {
    this.saveTarget.disabled = status;
    if (this.hasSaveReleaseTarget) {
      this.saveReleaseTarget.disabled = status;
    }
    if (this.hasSaveReleasePanelsTarget) {
      this.saveReleasePanelsTarget.disabled = status;
    }
  }

  saveForm(e) {
    if (!$(this.testResultsFormTarget).valid()) {
      e.preventDefault();
      this.addValidationWarningMessage(this.formStatusTarget);
      this.scrollToSpecimenForm(this.stsIdsValue);
    } else {
      e.target.click();
    }
  }

  addValidationWarningMessage(element) {
    const el = document.createElement("div");
    el.classList.add("alert", "alert-danger", "m-0");
    $(el).fadeOut(3000)

    el.textContent = i18next.t("Unable to save Test Results!");

    if (element.firstChild) {
      element.firstChild.replaceWith(el);
    } else {
      element.appendChild(el);
    }
  }

  scrollToSpecimenForm(sts_ids) {
    const currentElement = document.getElementById(
      `form_div_${sts_ids.join("_")}`,
    );

    currentElement?.nextSibling?.nextSibling?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }
}
